function throwErrorWithMessage(message: string, error?:any): never {
    const combinedMessage = error ? (message + ' | Error: ' + error) : message;
    throw new Error(combinedMessage);
}

export { throwErrorWithMessage }
